export const CODESNIPPET_COMPONENT_NAME = 'CodeSnippet';
